export const TIME_WINDOWS = Object.freeze([
  Object.freeze({ value: '1h', label: 'Last hour', shortLabel: '1h' }),
  Object.freeze({ value: '24h', label: 'Last 24 hours', shortLabel: '24h' }),
  Object.freeze({ value: '7d', label: 'Last 7 days', shortLabel: '7d' }),
  Object.freeze({ value: '30d', label: 'Last 30 days', shortLabel: '30d' }),
  Object.freeze({ value: '3m', label: 'Last 90 days', shortLabel: '3m' })
]);

export const TIME_WINDOW_VALUES = Object.freeze(TIME_WINDOWS.map(({ value }) => value));

export function isTimeWindow(value) {
  return TIME_WINDOW_VALUES.includes(value);
}

export function nextLargerTimeWindow(value) {
  const index = TIME_WINDOW_VALUES.indexOf(value);
  if (index < 0 || index === TIME_WINDOW_VALUES.length - 1) return null;
  return TIME_WINDOW_VALUES[index + 1];
}

export function formatExactPeriod(period) {
  if (!period?.start || !period?.end) return '';
  const formatWallTime = (iso) => {
    const match = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/);
    if (!match) return String(iso);
    const [, year, month, day, hour, minute, second] = match;
    const monthName = new Intl.DateTimeFormat('en-US', { month: 'short', timeZone: 'UTC' })
      .format(new Date(Date.UTC(2000, Number(month) - 1, 1)));
    return `${monthName} ${Number(day)}, ${year}, ${hour}:${minute}:${second}`;
  };
  return `${formatWallTime(period.start)} – ${formatWallTime(period.end)}`;
}
